<template>
    <section>
        <div class= "header">
            <h1 class="title">
            Items for Job # {{job_number}}
        </h1>
        </div>
        <div class = "body">
        <table v-for="(item, i) in items" :key="i">
            <tr>
                <td style="width: 35%">ID</td>
                <td>{{item.ID}}</td>
            </tr>
            <tr>
                <td>Quantity</td>
                <td>{{item.Quantity}}</td>
            </tr>
            <tr>
                <td>Price</td>
                <td>{{item.Price}}</td>
            </tr>
            <tr>
                <td>Name</td>
                <td>{{item.Name}}</td>
            </tr>
            <tr v-if="item.Comments">
                <td>Comments</td>
                <td>{{item.Comments}}</td>

            </tr>
            <tr>
                <td>Status</td>
                <td><span v-if="item._status.status_id === `accepted`">Accepted</span>
                    
                    <span v-if="item._status.rejection_reason">
                        <p>Rejected - {{item._status.rejection_reason.display}}</p>
                        <p>Notes: {{item._status.notes}}</p>
                    </span>
                    
                </td>          
            </tr>
            <tr class="noBorder">
                <br>
            </tr>
        </table>
        </div>
        <div class= "footer">
            <button class="btn" @click="close">Close</button>
        </div>
    </section>
</template>

<script>
export default {
    props: ['items', 'job_number'],
    methods: {
        close(){
            this.$emit('close');
        }
    }
}
</script>



<style scoped>
    .header {
        min-height: 16.428571429px;
        padding: 20px;
        border-bottom: 1px solid #e5e5e5;
    }

    .body{
        position: relative;
        padding: 20px;
        overflow: scroll;
        max-height: 70vh;
    }
    .footer{
        padding: 20px;
        border-top: 1px solid #e5e5e5;
        background-color: white;
    }
    
    td, th{
        border: 1px solid #dddddd;
        padding: 5px;
    }
    table{
        margin: '20px';
        margin-left: 'auto';
        margin-right: 'auto';
        width: 100%;
        border: white;
    }
    tr.noBorder td{
        border: 0;
    }

    td, th{
        padding: 5px;
    }

    button{
        width: 100px;
    }
</style>



// WEBPACK FOOTER //
// src/components/job/stop-action/ItemsForJobModal.vue